/**
 * custom.js
 * Site-wide jQuery behaviors. Existing gift + search logic is preserved.
 * Shop All mega-menu hover/panel logic is appended below (desktop only).
 * Mobile Shop All accordion lives in initShopAllMobileMenu().
 */

$(document).ready(function () {

  /* -------------------------------------------------------------------------
   * Start a Gift menu (existing — do not remove)
   * ---------------------------------------------------------------------- */
  $(".gift-btn").on("click", function (e) {
    e.stopPropagation();
    var $menu = $(".gift-menu");
    var willOpen = $menu.hasClass("hidden-menu");
    $menu.toggleClass("hidden-menu");
    $(this).attr("aria-expanded", willOpen ? "true" : "false");
  });

  // Prevent closing when clicking inside menu
  $(".gift-menu").on("click", function (e) {
    e.stopPropagation();
  });

  // Close when clicking outside
  $(document).on("click", function () {
    $(".gift-menu").addClass("hidden-menu");
    $(".gift-btn").attr("aria-expanded", "false");
  });

  /* -------------------------------------------------------------------------
   * Search bar popup (existing — do not remove)
   * ---------------------------------------------------------------------- */
  $(".search-input").on("click", function (e) {
    e.stopPropagation();
    $(".search-content").slideDown(200);
  });

  // Prevent close when clicking inside popup
  $(".search-content").on("click", function (e) {
    e.stopPropagation();
  });

  // Close when click outside
  $(document).on("click", function () {
    $(".search-content").slideUp(200);
  });

  const searchKey = "recent_searches";

  function loadRecentSearches() {
  let searches = JSON.parse(localStorage.getItem(searchKey)) || [];

  $(".recent-list").html("");

  if (searches.length === 0) {
    $(".recent-list").append("<li>No recent searches</li>");
    return;
  }

  // Show only first 3 recent searches
  searches.slice(0, 3).forEach(function (value) {
    $(".recent-list").append(`
      <li class="recent-item">
        <span class="search-value">${value}</span>
      </li>
    `);
  });
}

  // Save search
  function saveSearch(value) {
    value = value.trim();

    if (value === "") {
      return;
    }

    let searches = JSON.parse(localStorage.getItem(searchKey)) || [];

    // Remove duplicate
    searches = searches.filter(function (item) {
      return item !== value;
    });

    // Add latest search first
    searches.unshift(value);

    // Keep only last 5
    searches = searches.slice(0, 5);

    localStorage.setItem(searchKey, JSON.stringify(searches));

    loadRecentSearches();
  }

  // When user press enter in search box
  $(".search-input").on("keypress", function (e) {
    if (e.which == 13) {
      let value = $(this).val();
      saveSearch(value);
    }
  });

  // Click recent search
  $(document).on("click", ".search-value", function () {
    let value = $(this).text();
    $(".search-input").val(value);
  });

  // Remove individual search
  $(document).on("click", ".remove-search", function () {
    let index = $(this).data("index");

    let searches = JSON.parse(localStorage.getItem(searchKey)) || [];

    searches.splice(index, 1);

    localStorage.setItem(searchKey, JSON.stringify(searches));

    loadRecentSearches();
  });

  // Initial load
  loadRecentSearches();

  /* =========================================================================
   * Shop All Mega Menu
   * -------------------------------------------------------------------------
   * Requirements (from design screenshot):
   *  1) Hovering "Shop All" opens the two-pane mega panel.
   *  2) Hovering a left sidebar category swaps the right card panel.
   *  3) Leaving the menu closes it (desktop hover devices only).
   *  4) Other mega-menu / gift / search behavior must stay intact.
   *
   * Markup hooks:
   *  - details[data-shop-all-details]     → Shop All <details>
   *  - [data-shop-all-mega]               → two-pane root
   *  - [data-shop-all-cat]                → left category button
   *  - [data-shop-all-panel]              → right panel matching category
   * ========================================================================= */

  (function initShopAllMegaMenu() {
    var $shopAllDetails = $("details.mega-menu--shop-all[data-shop-all-details]");

    // Nothing to do if Shop All is not in the header menu
    if (!$shopAllDetails.length) {
      return;
    }

    var closeTimer = null;
    var HOVER_CLOSE_DELAY = 180; // ms — prevents flicker when moving between summary ↔ panel
    var canHover = window.matchMedia("(hover: hover) and (pointer: fine)").matches;
    var isDesktopNav = window.matchMedia("(min-width: 990px)").matches;

    /**
     * Open a Shop All <details> and keep sticky-header hide logic in sync
     * with theme HeaderMenu (preventHide).
     */
    function openShopAll($details) {
      if (!$details.length) return;

      // Close other open header mega menus so only one panel shows
      $("details.mega-menu[open]").not($details).each(function () {
        this.removeAttribute("open");
        var $summary = $(this).children("summary");
        $summary.attr("aria-expanded", "false");
      });

      $details.attr("open", true);
      $details.children("summary").attr("aria-expanded", "true");

      var headerWrapper = document.querySelector(".header-wrapper");
      if (headerWrapper) {
        headerWrapper.preventHide = true;
      }
    }

    /**
     * Close Shop All and restore sticky-header behavior.
     */
    function closeShopAll($details) {
      if (!$details.length) return;

      $details.removeAttr("open");
      $details.children("summary").attr("aria-expanded", "false");

      var headerWrapper = document.querySelector(".header-wrapper");
      if (headerWrapper) {
        headerWrapper.preventHide = false;
      }
    }

    /**
     * Activate a left-sidebar category and show its matching right panel.
     * Scoped to one mega root so multiple Shop All blocks (if any) stay isolated.
     */
    function activateCategory($mega, catIndex) {
      var index = String(catIndex);

      $mega.find("[data-shop-all-cat]").each(function () {
        var $btn = $(this);
        var isActive = String($btn.attr("data-shop-all-cat")) === index;
        $btn.toggleClass("is-active", isActive);
        $btn.attr("aria-expanded", isActive ? "true" : "false");
      });

      $mega.find("[data-shop-all-panel]").each(function () {
        var $panel = $(this);
        var isActive = String($panel.attr("data-shop-all-panel")) === index;
        $panel.toggleClass("is-active", isActive);
        if (isActive) {
          $panel.removeAttr("hidden");
        } else {
          $panel.attr("hidden", true);
        }
      });
    }

    // ----- Desktop hover: open / close Shop All -----
    if (canHover && isDesktopNav) {
      $shopAllDetails.each(function () {
        var $details = $(this);
        var $wrap = $details.closest("li");

        $wrap.on("mouseenter", function () {
          if (closeTimer) {
            clearTimeout(closeTimer);
            closeTimer = null;
          }
          openShopAll($details);
        });

        $wrap.on("mouseleave", function () {
          closeTimer = setTimeout(function () {
            closeShopAll($details);
          }, HOVER_CLOSE_DELAY);
        });
      });
    }

    // ----- Left category hover / focus / click → switch right panel -----
    // Delegated so it works if the header re-renders in the theme editor.
    $(document).on(
      "mouseenter focusin click",
      ".shop-all-mega [data-shop-all-cat]",
      function (e) {
        var $btn = $(this);
        var $mega = $btn.closest("[data-shop-all-mega]");
        var catIndex = $btn.attr("data-shop-all-cat");

        if (!$mega.length || !catIndex) return;

        // Buttons should not submit / bubble in ways that close the menu
        if (e.type === "click") {
          e.preventDefault();
        }

        activateCategory($mega, catIndex);
      }
    );

    // Keyboard: Escape closes Shop All without affecting other UI
    $(document).on("keydown", function (e) {
      if (e.key !== "Escape") return;

      $shopAllDetails.filter("[open]").each(function () {
        closeShopAll($(this));
      });
    });
  })();

  /* =========================================================================
   * Shop All — Mobile drawer accordion
   * -------------------------------------------------------------------------
   * Snippet: snippets/shop-all-mobile-menu.liquid
   * Uses capture-phase clicks so Dawn MenuDrawer does not treat our
   * buttons as submenu close / slide-in triggers.
   * ========================================================================= */
  (function initShopAllMobileMenu() {
    function setOpen($btn, $panel, open) {
      $btn.attr("aria-expanded", open ? "true" : "false");
      $btn.toggleClass("is-open", open);
      if (open) {
        $panel.removeAttr("hidden");
      } else {
        $panel.attr("hidden", true);
      }
    }

    function toggleRoot($root) {
      var $toggle = $root.find("[data-shop-all-mobile-toggle]").first();
      var $body = $root.find("[data-shop-all-mobile-body]").first();
      var open = $toggle.attr("aria-expanded") !== "true";
      setOpen($toggle, $body, open);
      $root.toggleClass("is-open", open);
    }

    function toggleCat($item) {
      var $btn = $item.find("[data-shop-all-mobile-cat]").first();
      var $cards = $item.find("[data-shop-all-mobile-cards]").first();
      if (!$btn.length || !$cards.length) return;

      var open = $btn.attr("aria-expanded") !== "true";

      // Accordion: close sibling categories
      $item.siblings("[data-shop-all-mobile-cat-item]").each(function () {
        var $sib = $(this);
        setOpen(
          $sib.find("[data-shop-all-mobile-cat]").first(),
          $sib.find("[data-shop-all-mobile-cards]").first(),
          false
        );
        $sib.removeClass("is-open");
      });

      setOpen($btn, $cards, open);
      $item.toggleClass("is-open", open);
    }

    // Capture phase — block Dawn MenuDrawer button close handlers
    document.addEventListener(
      "click",
      function (e) {
        var toggle = e.target.closest("[data-shop-all-mobile-toggle]");
        var cat = e.target.closest("[data-shop-all-mobile-cat]");

        if (toggle) {
          e.preventDefault();
          e.stopImmediatePropagation();
          toggleRoot($(toggle).closest("[data-shop-all-mobile]"));
          return;
        }

        if (cat) {
          e.preventDefault();
          e.stopImmediatePropagation();
          toggleCat($(cat).closest("[data-shop-all-mobile-cat-item]"));
        }
      },
      true
    );
  })();

  /* =========================================================================
   * Ready Made Hampers
   * -------------------------------------------------------------------------
   * Section: sections/ready-made-hampers.liquid
   * Styles:  assets/custom-ai.css
   * Slider:  Swiper 12 (CDN in theme.liquid) — https://swiperjs.com/get-started/
   *
   * Behaviour:
   *  1) Click a circular category tab → show matching product panel
   *  2) Init / re-init Swiper on the active panel for smooth sliding
   *  3) Variant pills update price + hidden variant id
   *  4) ADD uses Dawn <product-form> → cart drawer opens (product-form.js)
   *  5) After add, qty stepper (+/−) updates cart via cart/update.js
   * ========================================================================= */
  (function initReadyMadeHampers() {
    var SECTION_SEL = "[data-rmh-section]";
    var cartDataCache = null;

    function whenSwiperReady(callback, attempt) {
      attempt = attempt || 0;
      if (typeof window.Swiper === "function") {
        callback();
        return;
      }
      if (attempt > 40) {
        console.warn("[ReadyMadeHampers] Swiper library not found.");
        return;
      }
      setTimeout(function () {
        whenSwiperReady(callback, attempt + 1);
      }, 50);
    }

    function getDesktopColumns($section) {
      var cols = parseInt($section.attr("data-rmh-columns-desktop"), 10);
      if (!cols || cols < 4) cols = 4;
      if (cols > 6) cols = 6;
      return cols;
    }

    function createSwiper(swiperEl, $section) {
      if (!swiperEl || typeof window.Swiper !== "function") return null;

      if (swiperEl.swiper) {
        swiperEl.swiper.destroy(true, true);
      }

      var desktopCols = getDesktopColumns($section || $(swiperEl).closest(SECTION_SEL));
      var tabletCols = Math.max(2, desktopCols - 0.8);

      return new window.Swiper(swiperEl, {
        slidesPerView: 2,
        spaceBetween: 12,
        speed: 450,
        watchOverflow: true,
        grabCursor: true,
        resistanceRatio: 0.65,
        navigation: {
          nextEl: swiperEl.querySelector(".rmh-swiper__nav--next"),
          prevEl: swiperEl.querySelector(".rmh-swiper__nav--prev"),
        },
        breakpoints: {
          550: { slidesPerView: 2, spaceBetween: 12 },
          750: { slidesPerView: 2.4, spaceBetween: 18 },
          990: { slidesPerView: tabletCols, spaceBetween: 20 },
          1200: { slidesPerView: desktopCols, spaceBetween: 22 },
        },
      });
    }

    function activateTab($section, panelId) {
      var $tabs = $section.find("[data-rmh-tab]");
      var $panels = $section.find("[data-rmh-panel]");
      var $activeTab = $tabs.filter('[data-rmh-panel-id="' + panelId + '"]');
      var $activePanel = $panels.filter('[data-rmh-panel="' + panelId + '"]');

      if (!$activePanel.length) return;

      $tabs.removeClass("is-active").attr("aria-selected", "false");
      $activeTab.addClass("is-active").attr("aria-selected", "true");

      $panels.removeClass("is-active").attr("hidden", true);
      $activePanel.addClass("is-active").removeAttr("hidden");

      var collectionUrl = $activeTab.attr("data-rmh-collection-url");
      var $seeAll = $section.find("[data-rmh-see-all]");
      if ($seeAll.length && collectionUrl && collectionUrl !== "#") {
        $seeAll.attr("href", collectionUrl);
      }

      var swiperEl = $activePanel.find("[data-rmh-swiper]")[0];
      if (swiperEl) {
        requestAnimationFrame(function () {
          createSwiper(swiperEl, $section);
        });
      }
    }

    function getVariantQtyFromCart(cartData, variantId) {
      if (!cartData || !cartData.items) return 0;
      var id = Number(variantId);
      for (var i = 0; i < cartData.items.length; i++) {
        if (cartData.items[i].variant_id === id) {
          return cartData.items[i].quantity;
        }
      }
      return 0;
    }

    /**
     * /cart/add returns a single line item (no items[]).
     * /cart.js returns the full cart. Always normalize before syncing card UI.
     */
    function ensureFullCartData(data) {
      if (data && Array.isArray(data.items)) {
        return Promise.resolve(data);
      }
      return fetchCartData();
    }

    /** Toggle ADD button vs qty stepper on a product card */
    function updateCardCartUI($card, qty) {
      var $checkout = $card.find("[data-rmh-checkout]");
      var $formWrap = $card.find("[data-rmh-product-form]");
      var $qty = $card.find("[data-rmh-qty]");
      var $qtyValue = $card.find("[data-rmh-qty-value]");

      qty = Math.max(0, parseInt(qty, 10) || 0);
      $qtyValue.text(qty);

      if (qty > 0) {
        $card.addClass("is-in-cart");
        $checkout.addClass("is-in-cart");
        $formWrap.addClass("is-hidden");
        $qty.removeAttr("hidden").addClass("is-visible");
      } else {
        $card.removeClass("is-in-cart");
        $checkout.removeClass("is-in-cart");
        $formWrap.removeClass("is-hidden");
        $qty.attr("hidden", true).removeClass("is-visible");
      }
    }

    /** Refresh cart drawer + icon without opening drawer (qty +/-) */
    function renderCartSections(parsedState, openDrawer) {
      var cartDrawer = document.querySelector("cart-drawer");
      if (!cartDrawer || !parsedState.sections) return;

      if (parsedState.item_count > 0) {
        cartDrawer.classList.remove("is-empty");
      } else {
        cartDrawer.classList.add("is-empty");
      }

      cartDrawer.getSectionsToRender().forEach(function (section) {
        var sectionElement = section.selector
          ? document.querySelector(section.selector)
          : document.getElementById(section.id);
        if (!sectionElement || !parsedState.sections[section.id]) return;
        sectionElement.innerHTML = cartDrawer.getSectionInnerHTML(
          parsedState.sections[section.id],
          section.selector
        );
      });

      if (openDrawer && typeof cartDrawer.renderContents === "function") {
        cartDrawer.renderContents(parsedState);
      }
    }

    /** Update cart quantity for one variant (same API as Dawn quick-add-bulk) */
    function updateCartQuantity(variantId, quantity) {
      var body = JSON.stringify({
        updates: {},
        sections: ["cart-drawer", "cart-icon-bubble"],
        sections_url: window.location.pathname,
      });
      var payload = JSON.parse(body);
      payload.updates[String(variantId)] = quantity;

      return fetch(routes.cart_update_url, Object.assign({}, fetchConfig(), { body: JSON.stringify(payload) }))
        .then(function (res) {
          return res.json();
        })
        .then(function (parsedState) {
          if (parsedState.errors) {
            throw new Error(parsedState.errors);
          }
          cartDataCache = parsedState;
          renderCartSections(parsedState, false);
          if (typeof publish === "function" && typeof PUB_SUB_EVENTS !== "undefined") {
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: "ready-made-hampers",
              cartData: parsedState,
            });
          }
          return parsedState;
        });
    }

    function syncSectionCards($section, cartData) {
      if (!cartData) return;
      cartDataCache = cartData;
      $section.find("[data-rmh-card]").each(function () {
        var $card = $(this);
        var variantId = $card.find("[data-rmh-variant-input]").val();
        var qty = getVariantQtyFromCart(cartData, variantId);
        updateCardCartUI($card, qty);

        $card.find("[data-rmh-variant]").each(function () {
          var $pill = $(this);
          var pillVariantId = $pill.attr("data-variant-id");
          $pill.attr("data-variant-cart-qty", getVariantQtyFromCart(cartData, pillVariantId));
        });
      });
    }

    function fetchCartData() {
      var cartUrl = (typeof routes !== "undefined" && routes.cart_url) || "/cart";
      return fetch(cartUrl + ".js", { headers: { Accept: "application/json" } })
        .then(function (res) {
          return res.json();
        })
        .catch(function () {
          return null;
        });
    }

    function bindVariantPills($section) {
      $section.on("click.rmh", "[data-rmh-variant]", function () {
        var $btn = $(this);
        if ($btn.is(":disabled")) return;

        var $card = $btn.closest("[data-rmh-card]");
        var price = $btn.attr("data-variant-price");
        var variantId = $btn.attr("data-variant-id");
        var available = $btn.attr("data-variant-available") === "true";
        var variantCartQty = $btn.attr("data-variant-cart-qty");

        $card.find("[data-rmh-variant]").removeClass("is-active");
        $btn.addClass("is-active");

        if (price) {
          $card.find("[data-rmh-price]").text(price + "/-");
        }

        var $input = $card.find("[data-rmh-variant-input]");
        if ($input.length && variantId) {
          $input.val(variantId);
        }

        if (cartDataCache) {
          variantCartQty = getVariantQtyFromCart(cartDataCache, variantId);
        } else {
          variantCartQty = parseInt($btn.attr("data-variant-cart-qty"), 10) || 0;
        }

        updateCardCartUI($card, variantCartQty);

        if (!available) {
          $card.find("[data-rmh-product-form]").addClass("is-hidden");
          $card.find("[data-rmh-qty]").attr("hidden", true).removeClass("is-visible");
        }
      });
    }

    function bindQuantityControls($section) {
      $section.on("click.rmh", "[data-rmh-qty-plus]", function () {
        var $card = $(this).closest("[data-rmh-card]");
        var variantId = $card.find("[data-rmh-variant-input]").val();
        var currentQty = parseInt($card.find("[data-rmh-qty-value]").text(), 10) || 0;
        var $btn = $(this);

        if (!variantId) return;

        $btn.addClass("is-loading").prop("disabled", true);

        updateCartQuantity(variantId, currentQty + 1)
          .then(function (cartData) {
            syncSectionCards($section, cartData);
          })
          .catch(function (err) {
            console.warn("[ReadyMadeHampers] qty increase error:", err);
          })
          .finally(function () {
            $btn.removeClass("is-loading").prop("disabled", false);
          });
      });

      $section.on("click.rmh", "[data-rmh-qty-minus]", function () {
        var $card = $(this).closest("[data-rmh-card]");
        var variantId = $card.find("[data-rmh-variant-input]").val();
        var currentQty = parseInt($card.find("[data-rmh-qty-value]").text(), 10) || 0;
        var $btn = $(this);

        if (!variantId || currentQty <= 0) return;

        $btn.addClass("is-loading").prop("disabled", true);

        updateCartQuantity(variantId, currentQty - 1)
          .then(function (cartData) {
            syncSectionCards($section, cartData);
          })
          .catch(function (err) {
            console.warn("[ReadyMadeHampers] qty decrease error:", err);
          })
          .finally(function () {
            $btn.removeClass("is-loading").prop("disabled", false);
          });
      });
    }

    function subscribeCartUpdates($section) {
      if (typeof subscribe !== "function" || typeof PUB_SUB_EVENTS === "undefined") return;

      subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
        if (!event.cartData) return;

        ensureFullCartData(event.cartData).then(function (fullCart) {
          if (fullCart) syncSectionCards($section, fullCart);
        });
      });
    }

    function initSection(sectionEl) {
      var $section = $(sectionEl);
      if ($section.data("rmh-initialized")) return;
      $section.data("rmh-initialized", true);

      $section.off(".rmh");

      $section.on("click.rmh", "[data-rmh-tab]", function () {
        var panelId = $(this).attr("data-rmh-panel-id");
        if (panelId) activateTab($section, panelId);
      });

      bindVariantPills($section);
      bindQuantityControls($section);
      subscribeCartUpdates($section);

      fetchCartData().then(function (cartData) {
        if (cartData) syncSectionCards($section, cartData);
      });

      var $active = $section.find(".rmh__panel.is-active");
      var firstId = $active.attr("data-rmh-panel");
      if (firstId) {
        activateTab($section, firstId);
      }
    }

    function boot() {
      whenSwiperReady(function () {
        $(SECTION_SEL).each(function () {
          initSection(this);
        });
      });
    }

    boot();

    document.addEventListener("shopify:section:load", function (event) {
      var $root = $(event.target).find(SECTION_SEL).addBack(SECTION_SEL);
      $root.each(function () {
        $(this).removeData("rmh-initialized");
        initSection(this);
      });
    });
  })();

  /* =========================================================================
   * Best Selling Hampers
   * -------------------------------------------------------------------------
   * Section: sections/best-selling-hampers.liquid
   * Layout: left featured image + right product swiper
   * Cart:   same as Ready Made Hampers (drawer on ADD, qty stepper after add)
   * ========================================================================= */
  (function initBestSellingHampers() {
    var SECTION_SEL = "[data-bsh-section]";
    var cartDataCache = null;

    function whenSwiperReady(callback, attempt) {
      attempt = attempt || 0;
      if (typeof window.Swiper === "function") {
        callback();
        return;
      }
      if (attempt > 40) return;
      setTimeout(function () {
        whenSwiperReady(callback, attempt + 1);
      }, 50);
    }

    function getDesktopColumns($section) {
      var cols = parseInt($section.attr("data-bsh-columns-desktop"), 10);
      if (!cols || cols < 3) cols = 3;
      if (cols > 5) cols = 5;
      return cols;
    }

    function createSwiper(swiperEl, $section) {
      if (!swiperEl || typeof window.Swiper !== "function") return null;

      if (swiperEl.swiper) {
        swiperEl.swiper.destroy(true, true);
      }

      var desktopCols = getDesktopColumns($section);
      var tabletCols = Math.max(2, desktopCols - 0.8);

      return new window.Swiper(swiperEl, {
        slidesPerView: 1.15,
        spaceBetween: 16,
        speed: 450,
        watchOverflow: true,
        grabCursor: true,
        resistanceRatio: 0.65,
        navigation: {
          nextEl: swiperEl.querySelector(".bsh-swiper__nav--next"),
          prevEl: swiperEl.querySelector(".bsh-swiper__nav--prev"),
        },
        breakpoints: {
          550: { slidesPerView: 1.6, spaceBetween: 16 },
          750: { slidesPerView: 2.2, spaceBetween: 18 },
          990: { slidesPerView: tabletCols, spaceBetween: 20 },
          1200: { slidesPerView: desktopCols, spaceBetween: 22 },
        },
      });
    }

    function getVariantQtyFromCart(cartData, variantId) {
      if (!cartData || !cartData.items) return 0;
      var id = Number(variantId);
      for (var i = 0; i < cartData.items.length; i++) {
        if (cartData.items[i].variant_id === id) {
          return cartData.items[i].quantity;
        }
      }
      return 0;
    }

    function ensureFullCartData(data) {
      if (data && Array.isArray(data.items)) {
        return Promise.resolve(data);
      }
      return fetchCartData();
    }

    function updateCardCartUI($card, qty) {
      var $checkout = $card.find("[data-bsh-checkout]");
      var $formWrap = $card.find("[data-bsh-product-form]");
      var $qty = $card.find("[data-bsh-qty]");
      var $qtyValue = $card.find("[data-bsh-qty-value]");

      qty = Math.max(0, parseInt(qty, 10) || 0);
      $qtyValue.text(qty);

      if (qty > 0) {
        $card.addClass("is-in-cart");
        $checkout.addClass("is-in-cart");
        $formWrap.addClass("is-hidden");
        $qty.removeAttr("hidden").addClass("is-visible");
      } else {
        $card.removeClass("is-in-cart");
        $checkout.removeClass("is-in-cart");
        $formWrap.removeClass("is-hidden");
        $qty.attr("hidden", true).removeClass("is-visible");
      }
    }

    function renderCartSections(parsedState, openDrawer) {
      var cartDrawer = document.querySelector("cart-drawer");
      if (!cartDrawer || !parsedState.sections) return;

      if (parsedState.item_count > 0) {
        cartDrawer.classList.remove("is-empty");
      } else {
        cartDrawer.classList.add("is-empty");
      }

      cartDrawer.getSectionsToRender().forEach(function (section) {
        var sectionElement = section.selector
          ? document.querySelector(section.selector)
          : document.getElementById(section.id);
        if (!sectionElement || !parsedState.sections[section.id]) return;
        sectionElement.innerHTML = cartDrawer.getSectionInnerHTML(
          parsedState.sections[section.id],
          section.selector
        );
      });

      if (openDrawer && typeof cartDrawer.renderContents === "function") {
        cartDrawer.renderContents(parsedState);
      }
    }

    function updateCartQuantity(variantId, quantity) {
      var body = JSON.stringify({
        updates: {},
        sections: ["cart-drawer", "cart-icon-bubble"],
        sections_url: window.location.pathname,
      });
      var payload = JSON.parse(body);
      payload.updates[String(variantId)] = quantity;

      return fetch(routes.cart_update_url, Object.assign({}, fetchConfig(), { body: JSON.stringify(payload) }))
        .then(function (res) {
          return res.json();
        })
        .then(function (parsedState) {
          if (parsedState.errors) {
            throw new Error(parsedState.errors);
          }
          cartDataCache = parsedState;
          renderCartSections(parsedState, false);
          if (typeof publish === "function" && typeof PUB_SUB_EVENTS !== "undefined") {
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: "best-selling-hampers",
              cartData: parsedState,
            });
          }
          return parsedState;
        });
    }

    function syncSectionCards($section, cartData) {
      if (!cartData) return;
      cartDataCache = cartData;
      $section.find("[data-bsh-card]").each(function () {
        var $card = $(this);
        var variantId = $card.find("[data-bsh-variant-input]").val();
        var qty = getVariantQtyFromCart(cartData, variantId);
        updateCardCartUI($card, qty);

        $card.find("[data-bsh-variant]").each(function () {
          var $pill = $(this);
          var pillVariantId = $pill.attr("data-variant-id");
          $pill.attr("data-variant-cart-qty", getVariantQtyFromCart(cartData, pillVariantId));
        });
      });
    }

    function fetchCartData() {
      var cartUrl = (typeof routes !== "undefined" && routes.cart_url) || "/cart";
      return fetch(cartUrl + ".js", { headers: { Accept: "application/json" } })
        .then(function (res) {
          return res.json();
        })
        .catch(function () {
          return null;
        });
    }

    function bindVariantPills($section) {
      $section.on("click.bsh", "[data-bsh-variant]", function () {
        var $btn = $(this);
        if ($btn.is(":disabled")) return;

        var $card = $btn.closest("[data-bsh-card]");
        var price = $btn.attr("data-variant-price");
        var variantId = $btn.attr("data-variant-id");
        var available = $btn.attr("data-variant-available") === "true";
        var variantCartQty = $btn.attr("data-variant-cart-qty");

        $card.find("[data-bsh-variant]").removeClass("is-active");
        $btn.addClass("is-active");

        if (price) {
          $card.find("[data-bsh-price]").text(price + "/-");
        }

        var $input = $card.find("[data-bsh-variant-input]");
        if ($input.length && variantId) {
          $input.val(variantId);
        }

        if (cartDataCache) {
          variantCartQty = getVariantQtyFromCart(cartDataCache, variantId);
        } else {
          variantCartQty = parseInt($btn.attr("data-variant-cart-qty"), 10) || 0;
        }

        updateCardCartUI($card, variantCartQty);

        if (!available) {
          $card.find("[data-bsh-product-form]").addClass("is-hidden");
          $card.find("[data-bsh-qty]").attr("hidden", true).removeClass("is-visible");
        }
      });
    }

    function bindQuantityControls($section) {
      $section.on("click.bsh", "[data-bsh-qty-plus]", function () {
        var $card = $(this).closest("[data-bsh-card]");
        var variantId = $card.find("[data-bsh-variant-input]").val();
        var currentQty = parseInt($card.find("[data-bsh-qty-value]").text(), 10) || 0;
        var $btn = $(this);

        if (!variantId) return;

        $btn.addClass("is-loading").prop("disabled", true);

        updateCartQuantity(variantId, currentQty + 1)
          .then(function (cartData) {
            syncSectionCards($section, cartData);
          })
          .catch(function (err) {
            console.warn("[BestSellingHampers] qty increase error:", err);
          })
          .finally(function () {
            $btn.removeClass("is-loading").prop("disabled", false);
          });
      });

      $section.on("click.bsh", "[data-bsh-qty-minus]", function () {
        var $card = $(this).closest("[data-bsh-card]");
        var variantId = $card.find("[data-bsh-variant-input]").val();
        var currentQty = parseInt($card.find("[data-bsh-qty-value]").text(), 10) || 0;
        var $btn = $(this);

        if (!variantId || currentQty <= 0) return;

        $btn.addClass("is-loading").prop("disabled", true);

        updateCartQuantity(variantId, currentQty - 1)
          .then(function (cartData) {
            syncSectionCards($section, cartData);
          })
          .catch(function (err) {
            console.warn("[BestSellingHampers] qty decrease error:", err);
          })
          .finally(function () {
            $btn.removeClass("is-loading").prop("disabled", false);
          });
      });
    }

    function subscribeCartUpdates($section) {
      if (typeof subscribe !== "function" || typeof PUB_SUB_EVENTS === "undefined") return;

      subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
        if (!event.cartData) return;

        ensureFullCartData(event.cartData).then(function (fullCart) {
          if (fullCart) syncSectionCards($section, fullCart);
        });
      });
    }

    function initSection(sectionEl) {
      var $section = $(sectionEl);
      if ($section.data("bsh-initialized")) return;
      $section.data("bsh-initialized", true);

      $section.off(".bsh");
      bindVariantPills($section);
      bindQuantityControls($section);
      subscribeCartUpdates($section);

      fetchCartData().then(function (cartData) {
        if (cartData) syncSectionCards($section, cartData);
      });

      var swiperEl = $section.find("[data-bsh-swiper]")[0];
      if (swiperEl) {
        createSwiper(swiperEl, $section);
      }
    }

    function boot() {
      whenSwiperReady(function () {
        $(SECTION_SEL).each(function () {
          initSection(this);
        });
      });
    }

    boot();

    document.addEventListener("shopify:section:load", function (event) {
      var $root = $(event.target).find(SECTION_SEL).addBack(SECTION_SEL);
      $root.each(function () {
        $(this).removeData("bsh-initialized");
        initSection(this);
      });
    });
  })();

  /* =========================================================================
   * Gift With Haldiram's
   * -------------------------------------------------------------------------
   * Section: sections/gift-with-haldirams.liquid
   * Text tabs + category card grid (no Swiper)
   * ========================================================================= */
  (function initGiftWithHaldirams() {
    var SECTION_SEL = "[data-gwh-section]";

    function activateTab($section, panelId) {
      var $tabs = $section.find("[data-gwh-tab]");
      var $panels = $section.find("[data-gwh-panel]");
      var $activeTab = $tabs.filter('[data-gwh-panel-id="' + panelId + '"]');
      var $activePanel = $panels.filter('[data-gwh-panel="' + panelId + '"]');

      if (!$activeTab.length || !$activePanel.length) return;

      $tabs.removeClass("is-active").attr("aria-selected", "false");
      $activeTab.addClass("is-active").attr("aria-selected", "true");

      $panels.removeClass("is-active").attr("hidden", true);
      $activePanel.addClass("is-active").removeAttr("hidden");

      var seeAllUrl = $activeTab.attr("data-gwh-see-all-url");
      var $seeAll = $section.find("[data-gwh-see-all]");
      if ($seeAll.length && seeAllUrl && seeAllUrl !== "#") {
        $seeAll.attr("href", seeAllUrl);
      }
    }

    function initSection(sectionEl) {
      var $section = $(sectionEl);
      if ($section.data("gwh-initialized")) return;
      $section.data("gwh-initialized", true);

      $section.off(".gwh");

      $section.on("click.gwh", "[data-gwh-tab]", function () {
        var panelId = $(this).attr("data-gwh-panel-id");
        if (panelId) activateTab($section, panelId);
      });
    }

    function boot() {
      $(SECTION_SEL).each(function () {
        initSection(this);
      });
    }

    boot();

    document.addEventListener("shopify:section:load", function (event) {
      var $root = $(event.target).find(SECTION_SEL).addBack(SECTION_SEL);
      $root.each(function () {
        $(this).removeData("gwh-initialized");
        initSection(this);
      });
    });
  })();

  /* =========================================================================
   * Our Best Sellers
   * -------------------------------------------------------------------------
   * Section: sections/our-best-sellers.liquid
   * Layout: heading + see-all + full-width product swiper
   * Cart:   same as Ready Made Hampers (drawer on ADD, qty stepper after add)
   * ========================================================================= */
  (function initOurBestSellers() {
    var SECTION_SEL = "[data-obs-section]";
    var cartDataCache = null;

    function whenSwiperReady(callback, attempt) {
      attempt = attempt || 0;
      if (typeof window.Swiper === "function") {
        callback();
        return;
      }
      if (attempt > 40) return;
      setTimeout(function () {
        whenSwiperReady(callback, attempt + 1);
      }, 50);
    }

    function getDesktopColumns($section) {
      var cols = parseInt($section.attr("data-obs-columns-desktop"), 10);
      if (!cols || cols < 3) cols = 3;
      if (cols > 5) cols = 5;
      return cols;
    }

    function createSwiper(swiperEl, $section) {
      if (!swiperEl || typeof window.Swiper !== "function") return null;

      if (swiperEl.swiper) {
        swiperEl.swiper.destroy(true, true);
      }

      var desktopCols = getDesktopColumns($section);
      var tabletCols = Math.max(2, desktopCols - 0.8);

      return new window.Swiper(swiperEl, {
        slidesPerView: 1.15,
        spaceBetween: 16,
        speed: 450,
        watchOverflow: true,
        grabCursor: true,
        resistanceRatio: 0.65,
        navigation: {
          nextEl: swiperEl.querySelector(".obs-swiper__nav--next"),
          prevEl: swiperEl.querySelector(".obs-swiper__nav--prev"),
        },
        breakpoints: {
          550: { slidesPerView: 1.6, spaceBetween: 16 },
          750: { slidesPerView: 2.4, spaceBetween: 18 },
          990: { slidesPerView: tabletCols, spaceBetween: 20 },
          1200: { slidesPerView: desktopCols, spaceBetween: 22 },
        },
      });
    }

    function getVariantQtyFromCart(cartData, variantId) {
      if (!cartData || !cartData.items) return 0;
      var id = Number(variantId);
      for (var i = 0; i < cartData.items.length; i++) {
        if (cartData.items[i].variant_id === id) {
          return cartData.items[i].quantity;
        }
      }
      return 0;
    }

    function ensureFullCartData(data) {
      if (data && Array.isArray(data.items)) {
        return Promise.resolve(data);
      }
      return fetchCartData();
    }

    function updateCardCartUI($card, qty) {
      var $checkout = $card.find("[data-obs-checkout]");
      var $formWrap = $card.find("[data-obs-product-form]");
      var $qty = $card.find("[data-obs-qty]");
      var $qtyValue = $card.find("[data-obs-qty-value]");

      qty = Math.max(0, parseInt(qty, 10) || 0);
      $qtyValue.text(qty);

      if (qty > 0) {
        $card.addClass("is-in-cart");
        $checkout.addClass("is-in-cart");
        $formWrap.addClass("is-hidden");
        $qty.removeAttr("hidden").addClass("is-visible");
      } else {
        $card.removeClass("is-in-cart");
        $checkout.removeClass("is-in-cart");
        $formWrap.removeClass("is-hidden");
        $qty.attr("hidden", true).removeClass("is-visible");
      }
    }

    function renderCartSections(parsedState, openDrawer) {
      var cartDrawer = document.querySelector("cart-drawer");
      if (!cartDrawer || !parsedState.sections) return;

      if (parsedState.item_count > 0) {
        cartDrawer.classList.remove("is-empty");
      } else {
        cartDrawer.classList.add("is-empty");
      }

      cartDrawer.getSectionsToRender().forEach(function (section) {
        var sectionElement = section.selector
          ? document.querySelector(section.selector)
          : document.getElementById(section.id);
        if (!sectionElement || !parsedState.sections[section.id]) return;
        sectionElement.innerHTML = cartDrawer.getSectionInnerHTML(
          parsedState.sections[section.id],
          section.selector
        );
      });

      if (openDrawer && typeof cartDrawer.renderContents === "function") {
        cartDrawer.renderContents(parsedState);
      }
    }

    function updateCartQuantity(variantId, quantity) {
      var body = JSON.stringify({
        updates: {},
        sections: ["cart-drawer", "cart-icon-bubble"],
        sections_url: window.location.pathname,
      });
      var payload = JSON.parse(body);
      payload.updates[String(variantId)] = quantity;

      return fetch(routes.cart_update_url, Object.assign({}, fetchConfig(), { body: JSON.stringify(payload) }))
        .then(function (res) {
          return res.json();
        })
        .then(function (parsedState) {
          if (parsedState.errors) {
            throw new Error(parsedState.errors);
          }
          cartDataCache = parsedState;
          renderCartSections(parsedState, false);
          if (typeof publish === "function" && typeof PUB_SUB_EVENTS !== "undefined") {
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: "our-best-sellers",
              cartData: parsedState,
            });
          }
          return parsedState;
        });
    }

    function syncSectionCards($section, cartData) {
      if (!cartData) return;
      cartDataCache = cartData;
      $section.find("[data-obs-card]").each(function () {
        var $card = $(this);
        var variantId = $card.find("[data-obs-variant-input]").val();
        var qty = getVariantQtyFromCart(cartData, variantId);
        updateCardCartUI($card, qty);

        $card.find("[data-obs-variant]").each(function () {
          var $pill = $(this);
          var pillVariantId = $pill.attr("data-variant-id");
          $pill.attr("data-variant-cart-qty", getVariantQtyFromCart(cartData, pillVariantId));
        });
      });
    }

    function fetchCartData() {
      var cartUrl = (typeof routes !== "undefined" && routes.cart_url) || "/cart";
      return fetch(cartUrl + ".js", { headers: { Accept: "application/json" } })
        .then(function (res) {
          return res.json();
        })
        .catch(function () {
          return null;
        });
    }

    function bindVariantPills($section) {
      $section.on("click.obs", "[data-obs-variant]", function () {
        var $btn = $(this);
        if ($btn.is(":disabled")) return;

        var $card = $btn.closest("[data-obs-card]");
        var price = $btn.attr("data-variant-price");
        var variantId = $btn.attr("data-variant-id");
        var available = $btn.attr("data-variant-available") === "true";
        var variantCartQty = $btn.attr("data-variant-cart-qty");

        $card.find("[data-obs-variant]").removeClass("is-active");
        $btn.addClass("is-active");

        if (price) {
          $card.find("[data-obs-price]").text(price + "/-");
        }

        var $input = $card.find("[data-obs-variant-input]");
        if ($input.length && variantId) {
          $input.val(variantId);
        }

        if (cartDataCache) {
          variantCartQty = getVariantQtyFromCart(cartDataCache, variantId);
        } else {
          variantCartQty = parseInt($btn.attr("data-variant-cart-qty"), 10) || 0;
        }

        updateCardCartUI($card, variantCartQty);

        if (!available) {
          $card.find("[data-obs-product-form]").addClass("is-hidden");
          $card.find("[data-obs-qty]").attr("hidden", true).removeClass("is-visible");
        }
      });
    }

    function bindQuantityControls($section) {
      $section.on("click.obs", "[data-obs-qty-plus]", function () {
        var $card = $(this).closest("[data-obs-card]");
        var variantId = $card.find("[data-obs-variant-input]").val();
        var currentQty = parseInt($card.find("[data-obs-qty-value]").text(), 10) || 0;
        var $btn = $(this);

        if (!variantId) return;

        $btn.addClass("is-loading").prop("disabled", true);

        updateCartQuantity(variantId, currentQty + 1)
          .then(function (cartData) {
            syncSectionCards($section, cartData);
          })
          .catch(function (err) {
            console.warn("[OurBestSellers] qty increase error:", err);
          })
          .finally(function () {
            $btn.removeClass("is-loading").prop("disabled", false);
          });
      });

      $section.on("click.obs", "[data-obs-qty-minus]", function () {
        var $card = $(this).closest("[data-obs-card]");
        var variantId = $card.find("[data-obs-variant-input]").val();
        var currentQty = parseInt($card.find("[data-obs-qty-value]").text(), 10) || 0;
        var $btn = $(this);

        if (!variantId || currentQty <= 0) return;

        $btn.addClass("is-loading").prop("disabled", true);

        updateCartQuantity(variantId, currentQty - 1)
          .then(function (cartData) {
            syncSectionCards($section, cartData);
          })
          .catch(function (err) {
            console.warn("[OurBestSellers] qty decrease error:", err);
          })
          .finally(function () {
            $btn.removeClass("is-loading").prop("disabled", false);
          });
      });
    }

    function subscribeCartUpdates($section) {
      if (typeof subscribe !== "function" || typeof PUB_SUB_EVENTS === "undefined") return;

      subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
        if (!event.cartData) return;

        ensureFullCartData(event.cartData).then(function (fullCart) {
          if (fullCart) syncSectionCards($section, fullCart);
        });
      });
    }

    function initSection(sectionEl) {
      var $section = $(sectionEl);
      if ($section.data("obs-initialized")) return;
      $section.data("obs-initialized", true);

      $section.off(".obs");
      bindVariantPills($section);
      bindQuantityControls($section);
      subscribeCartUpdates($section);

      fetchCartData().then(function (cartData) {
        if (cartData) syncSectionCards($section, cartData);
      });

      var swiperEl = $section.find("[data-obs-swiper]")[0];
      if (swiperEl) {
        createSwiper(swiperEl, $section);
      }
    }

    function boot() {
      whenSwiperReady(function () {
        $(SECTION_SEL).each(function () {
          initSection(this);
        });
      });
    }

    boot();

    document.addEventListener("shopify:section:load", function (event) {
      var $root = $(event.target).find(SECTION_SEL).addBack(SECTION_SEL);
      $root.each(function () {
        $(this).removeData("obs-initialized");
        initSection(this);
      });
    });
  })();

  /* =========================================================================
   * Mahalaxmi (New at Haldiram's style)
   * -------------------------------------------------------------------------
   * Section: sections/mahalaxmi.liquid
   * Layout: heading + header arrows + large horizontal product cards
   * Cart:   same as Ready Made Hampers (drawer on ADD, qty stepper after add)
   * ========================================================================= */
  (function initMahalaxmi() {
    var SECTION_SEL = "[data-mah-section]";
    var cartDataCache = null;

    function whenSwiperReady(callback, attempt) {
      attempt = attempt || 0;
      if (typeof window.Swiper === "function") {
        callback();
        return;
      }
      if (attempt > 40) return;
      setTimeout(function () {
        whenSwiperReady(callback, attempt + 1);
      }, 50);
    }

    function createSwiper(swiperEl, $section) {
      if (!swiperEl || typeof window.Swiper !== "function") return null;

      if (swiperEl.swiper) {
        swiperEl.swiper.destroy(true, true);
      }

      return new window.Swiper(swiperEl, {
        slidesPerView: 1.05,
        spaceBetween: 16,
        speed: 450,
        watchOverflow: true,
        grabCursor: true,
        resistanceRatio: 0.65,
        navigation: {
          nextEl: $section.find(".mah__nav-btn--next")[0],
          prevEl: $section.find(".mah__nav-btn--prev")[0],
        },
        breakpoints: {
          750: { slidesPerView: 1.15, spaceBetween: 22 },
          990: { slidesPerView: 1.25, spaceBetween: 24 },
          1200: { slidesPerView: 1.35, spaceBetween: 28 },
        },
      });
    }

    function getVariantQtyFromCart(cartData, variantId) {
      if (!cartData || !cartData.items) return 0;
      var id = Number(variantId);
      for (var i = 0; i < cartData.items.length; i++) {
        if (cartData.items[i].variant_id === id) {
          return cartData.items[i].quantity;
        }
      }
      return 0;
    }

    function ensureFullCartData(data) {
      if (data && Array.isArray(data.items)) {
        return Promise.resolve(data);
      }
      return fetchCartData();
    }

    function updateCardCartUI($card, qty) {
      var $checkout = $card.find("[data-mah-checkout]");
      var $formWrap = $card.find("[data-mah-product-form]");
      var $qty = $card.find("[data-mah-qty]");
      var $qtyValue = $card.find("[data-mah-qty-value]");

      qty = Math.max(0, parseInt(qty, 10) || 0);
      $qtyValue.text(qty);

      if (qty > 0) {
        $card.addClass("is-in-cart");
        $checkout.addClass("is-in-cart");
        $formWrap.addClass("is-hidden");
        $qty.removeAttr("hidden").addClass("is-visible");
      } else {
        $card.removeClass("is-in-cart");
        $checkout.removeClass("is-in-cart");
        $formWrap.removeClass("is-hidden");
        $qty.attr("hidden", true).removeClass("is-visible");
      }
    }

    function renderCartSections(parsedState) {
      var cartDrawer = document.querySelector("cart-drawer");
      if (!cartDrawer || !parsedState.sections) return;

      if (parsedState.item_count > 0) {
        cartDrawer.classList.remove("is-empty");
      } else {
        cartDrawer.classList.add("is-empty");
      }

      cartDrawer.getSectionsToRender().forEach(function (section) {
        var sectionElement = section.selector
          ? document.querySelector(section.selector)
          : document.getElementById(section.id);
        if (!sectionElement || !parsedState.sections[section.id]) return;
        sectionElement.innerHTML = cartDrawer.getSectionInnerHTML(
          parsedState.sections[section.id],
          section.selector
        );
      });
    }

    function updateCartQuantity(variantId, quantity) {
      var payload = {
        updates: {},
        sections: ["cart-drawer", "cart-icon-bubble"],
        sections_url: window.location.pathname,
      };
      payload.updates[String(variantId)] = quantity;

      return fetch(routes.cart_update_url, Object.assign({}, fetchConfig(), { body: JSON.stringify(payload) }))
        .then(function (res) {
          return res.json();
        })
        .then(function (parsedState) {
          if (parsedState.errors) {
            throw new Error(parsedState.errors);
          }
          cartDataCache = parsedState;
          renderCartSections(parsedState);
          if (typeof publish === "function" && typeof PUB_SUB_EVENTS !== "undefined") {
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: "mahalaxmi",
              cartData: parsedState,
            });
          }
          return parsedState;
        });
    }

    function syncSectionCards($section, cartData) {
      if (!cartData) return;
      cartDataCache = cartData;
      $section.find("[data-mah-card]").each(function () {
        var $card = $(this);
        var variantId = $card.find("[data-mah-variant-input]").val();
        var qty = getVariantQtyFromCart(cartData, variantId);
        updateCardCartUI($card, qty);

        $card.find("[data-mah-variant]").each(function () {
          var $pill = $(this);
          $pill.attr(
            "data-variant-cart-qty",
            getVariantQtyFromCart(cartData, $pill.attr("data-variant-id"))
          );
        });
      });
    }

    function fetchCartData() {
      var cartUrl = (typeof routes !== "undefined" && routes.cart_url) || "/cart";
      return fetch(cartUrl + ".js", { headers: { Accept: "application/json" } })
        .then(function (res) {
          return res.json();
        })
        .catch(function () {
          return null;
        });
    }

    function bindVariantPills($section) {
      $section.on("click.mah", "[data-mah-variant]", function () {
        var $btn = $(this);
        if ($btn.is(":disabled")) return;

        var $card = $btn.closest("[data-mah-card]");
        var price = $btn.attr("data-variant-price");
        var variantId = $btn.attr("data-variant-id");
        var available = $btn.attr("data-variant-available") === "true";
        var variantCartQty;

        $card.find("[data-mah-variant]").removeClass("is-active");
        $btn.addClass("is-active");

        if (price) {
          $card.find("[data-mah-price]").text(price + "/-");
        }

        var $input = $card.find("[data-mah-variant-input]");
        if ($input.length && variantId) {
          $input.val(variantId);
        }

        if (cartDataCache) {
          variantCartQty = getVariantQtyFromCart(cartDataCache, variantId);
        } else {
          variantCartQty = parseInt($btn.attr("data-variant-cart-qty"), 10) || 0;
        }

        updateCardCartUI($card, variantCartQty);

        if (!available) {
          $card.find("[data-mah-product-form]").addClass("is-hidden");
          $card.find("[data-mah-qty]").attr("hidden", true).removeClass("is-visible");
        }
      });
    }

    function bindQuantityControls($section) {
      $section.on("click.mah", "[data-mah-qty-plus]", function () {
        var $card = $(this).closest("[data-mah-card]");
        var variantId = $card.find("[data-mah-variant-input]").val();
        var currentQty = parseInt($card.find("[data-mah-qty-value]").text(), 10) || 0;
        var $btn = $(this);
        if (!variantId) return;

        $btn.addClass("is-loading").prop("disabled", true);
        updateCartQuantity(variantId, currentQty + 1)
          .then(function (cartData) {
            syncSectionCards($section, cartData);
          })
          .catch(function (err) {
            console.warn("[Mahalaxmi] qty increase error:", err);
          })
          .finally(function () {
            $btn.removeClass("is-loading").prop("disabled", false);
          });
      });

      $section.on("click.mah", "[data-mah-qty-minus]", function () {
        var $card = $(this).closest("[data-mah-card]");
        var variantId = $card.find("[data-mah-variant-input]").val();
        var currentQty = parseInt($card.find("[data-mah-qty-value]").text(), 10) || 0;
        var $btn = $(this);
        if (!variantId || currentQty <= 0) return;

        $btn.addClass("is-loading").prop("disabled", true);
        updateCartQuantity(variantId, currentQty - 1)
          .then(function (cartData) {
            syncSectionCards($section, cartData);
          })
          .catch(function (err) {
            console.warn("[Mahalaxmi] qty decrease error:", err);
          })
          .finally(function () {
            $btn.removeClass("is-loading").prop("disabled", false);
          });
      });
    }

    function subscribeCartUpdates($section) {
      if (typeof subscribe !== "function" || typeof PUB_SUB_EVENTS === "undefined") return;

      subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
        if (!event.cartData) return;
        ensureFullCartData(event.cartData).then(function (fullCart) {
          if (fullCart) syncSectionCards($section, fullCart);
        });
      });
    }

    function initSection(sectionEl) {
      var $section = $(sectionEl);
      if ($section.data("mah-initialized")) return;
      $section.data("mah-initialized", true);

      $section.off(".mah");
      bindVariantPills($section);
      bindQuantityControls($section);
      subscribeCartUpdates($section);

      fetchCartData().then(function (cartData) {
        if (cartData) syncSectionCards($section, cartData);
      });

      var swiperEl = $section.find("[data-mah-swiper]")[0];
      if (swiperEl) {
        createSwiper(swiperEl, $section);
      }
    }

    function boot() {
      whenSwiperReady(function () {
        $(SECTION_SEL).each(function () {
          initSection(this);
        });
      });
    }

    boot();

    document.addEventListener("shopify:section:load", function (event) {
      var $root = $(event.target).find(SECTION_SEL).addBack(SECTION_SEL);
      $root.each(function () {
        $(this).removeData("mah-initialized");
        initSection(this);
      });
    });
  })();

  /* =========================================================================
   * Hungry for Haldiram's (Recipes)
   * -------------------------------------------------------------------------
   * Section: sections/hungry-for-haldirams.liquid
   * Swiper cards + Play Video modal (YouTube / Vimeo / Shopify video)
   * ========================================================================= */
  (function initHungryForHaldirams() {
    var SECTION_SEL = "[data-hfh-section]";

    function whenSwiperReady(callback, attempt) {
      attempt = attempt || 0;
      if (typeof window.Swiper === "function") {
        callback();
        return;
      }
      if (attempt > 40) return;
      setTimeout(function () {
        whenSwiperReady(callback, attempt + 1);
      }, 50);
    }

    function getDesktopColumns($section) {
      var cols = parseInt($section.attr("data-hfh-columns"), 10);
      if (!cols || cols < 3) cols = 3;
      if (cols > 4) cols = 4;
      return cols;
    }

    function createSwiper(swiperEl, $section) {
      if (!swiperEl || typeof window.Swiper !== "function") return null;

      if (swiperEl.swiper) {
        swiperEl.swiper.destroy(true, true);
      }

      var desktopCols = getDesktopColumns($section);

      return new window.Swiper(swiperEl, {
        slidesPerView: 1.15,
        spaceBetween: 16,
        speed: 450,
        watchOverflow: true,
        grabCursor: true,
        resistanceRatio: 0.65,
        navigation: {
          nextEl: $section.find(".hfh__nav-btn--next")[0],
          prevEl: $section.find(".hfh__nav-btn--prev")[0],
        },
        breakpoints: {
          550: { slidesPerView: 1.6, spaceBetween: 16 },
          750: { slidesPerView: 2.2, spaceBetween: 18 },
          990: { slidesPerView: Math.min(3, desktopCols), spaceBetween: 20 },
          1200: { slidesPerView: desktopCols, spaceBetween: 22 },
        },
      });
    }

    function parseExternalVideo(url) {
      if (!url) return null;
      url = String(url).trim();

      // YouTube Shorts: youtube.com/shorts/ID
      var shorts = url.match(/youtube\.com\/shorts\/([A-Za-z0-9_-]{6,})/i);
      if (shorts) {
        return { type: "youtube", id: shorts[1] };
      }

      // youtu.be/ID
      var shortLink = url.match(/youtu\.be\/([A-Za-z0-9_-]{6,})/i);
      if (shortLink) {
        return { type: "youtube", id: shortLink[1] };
      }

      // youtube.com/watch?v=ID  OR  youtube.com/embed/ID
      var watch = url.match(
        /(?:youtube\.com\/(?:watch\?(?:[^#]*&)?v=|embed\/|live\/|v\/)|youtube-nocookie\.com\/embed\/)([A-Za-z0-9_-]{6,})/i
      );
      if (watch) {
        return { type: "youtube", id: watch[1] };
      }

      // vimeo.com/ID
      var vimeo = url.match(/vimeo\.com\/(?:video\/)?(\d+)/i);
      if (vimeo) {
        return { type: "vimeo", id: vimeo[1] };
      }

      return null;
    }

    function buildVideoHtml($btn) {
      var type = $btn.attr("data-video-type");
      var src = $btn.attr("data-video-src");
      var poster = $btn.attr("data-video-poster") || "";
      var id = $btn.attr("data-video-id");

      if (type === "external") {
        var parsed = parseExternalVideo($btn.attr("data-video-url"));
        if (!parsed) return "";
        type = parsed.type;
        id = parsed.id;
      }

      if (type === "youtube" && id) {
        return (
          '<iframe src="https://www.youtube.com/embed/' +
          id +
          '?autoplay=1&rel=0" title="Recipe video" allow="autoplay; encrypted-media; picture-in-picture" allowfullscreen></iframe>'
        );
      }

      if (type === "vimeo" && id) {
        return (
          '<iframe src="https://player.vimeo.com/video/' +
          id +
          '?autoplay=1" title="Recipe video" allow="autoplay; encrypted-media; picture-in-picture" allowfullscreen></iframe>'
        );
      }

      if (type === "shopify" && src) {
        return (
          '<video controls autoplay playsinline' +
          (poster ? ' poster="' + poster + '"' : "") +
          ' src="' +
          src +
          '"></video>'
        );
      }

      return "";
    }

    function openModal($section, $btn) {
      var $modal = $section.find("[data-hfh-modal]");
      var $frame = $section.find("[data-hfh-modal-frame]");
      var html = buildVideoHtml($btn);

      if (!html || !$modal.length) return;

      $frame.html(html);
      $modal.removeAttr("hidden");
      document.body.classList.add("hfh-modal-open");
      $section.find("[data-hfh-modal-close]").first().trigger("focus");
    }

    function closeModal($section) {
      var $modal = $section.find("[data-hfh-modal]");
      var $frame = $section.find("[data-hfh-modal-frame]");

      $frame.empty();
      $modal.attr("hidden", true);
      document.body.classList.remove("hfh-modal-open");
    }

    function bindModal($section) {
      $section.on("click.hfh", "[data-hfh-play]", function (e) {
        e.preventDefault();
        openModal($section, $(this));
      });

      $section.on("click.hfh", "[data-hfh-modal-close]", function () {
        closeModal($section);
      });

      $(document).on("keydown.hfh-" + $section.attr("data-section-id"), function (e) {
        if (e.key === "Escape") {
          closeModal($section);
        }
      });
    }

    function initSection(sectionEl) {
      var $section = $(sectionEl);
      if ($section.data("hfh-initialized")) return;
      $section.data("hfh-initialized", true);

      $section.off(".hfh");
      $(document).off("keydown.hfh-" + $section.attr("data-section-id"));
      bindModal($section);

      var swiperEl = $section.find("[data-hfh-swiper]")[0];
      if (swiperEl) {
        createSwiper(swiperEl, $section);
      }
    }

    function boot() {
      whenSwiperReady(function () {
        $(SECTION_SEL).each(function () {
          initSection(this);
        });
      });
    }

    boot();

    document.addEventListener("shopify:section:load", function (event) {
      var $root = $(event.target).find(SECTION_SEL).addBack(SECTION_SEL);
      $root.each(function () {
        $(this).removeData("hfh-initialized");
        initSection(this);
      });
    });
  })();

  /* =========================================================================
   * Card Product V2 (site-wide)
   * -------------------------------------------------------------------------
   * Snippet: snippets/card-product-v2.liquid
   * Cart: same as Best Selling Hampers (drawer on ADD, qty stepper after)
   * ========================================================================= */
  (function initCardProductV2() {
    var CARD_SEL = "[data-cpv2-card]";
    var cartDataCache = null;
    var bound = false;

    function getVariantQtyFromCart(cartData, variantId) {
      if (!cartData || !cartData.items) return 0;
      var id = Number(variantId);
      for (var i = 0; i < cartData.items.length; i++) {
        if (cartData.items[i].variant_id === id) {
          return cartData.items[i].quantity;
        }
      }
      return 0;
    }

    function fetchCartData() {
      var cartUrl = (typeof routes !== "undefined" && routes.cart_url) || "/cart";
      return fetch(cartUrl + ".js", { headers: { Accept: "application/json" } })
        .then(function (res) {
          return res.json();
        })
        .catch(function () {
          return null;
        });
    }

    function ensureFullCartData(data) {
      if (data && Array.isArray(data.items)) {
        return Promise.resolve(data);
      }
      return fetchCartData();
    }

    function updateCardCartUI($card, qty) {
      var $checkout = $card.find("[data-cpv2-checkout]");
      var $formWrap = $card.find("[data-cpv2-product-form]");
      var $qty = $card.find("[data-cpv2-qty]");
      var $qtyValue = $card.find("[data-cpv2-qty-value]");

      qty = Math.max(0, parseInt(qty, 10) || 0);
      $qtyValue.text(qty);

      if (qty > 0) {
        $card.addClass("is-in-cart");
        $checkout.addClass("is-in-cart");
        $formWrap.addClass("is-hidden");
        $qty.removeAttr("hidden").addClass("is-visible");
      } else {
        $card.removeClass("is-in-cart");
        $checkout.removeClass("is-in-cart");
        $formWrap.removeClass("is-hidden");
        $qty.attr("hidden", true).removeClass("is-visible");
      }
    }

    function renderCartSections(parsedState) {
      var cartDrawer = document.querySelector("cart-drawer");
      if (!cartDrawer || !parsedState.sections) return;

      if (parsedState.item_count > 0) {
        cartDrawer.classList.remove("is-empty");
      } else {
        cartDrawer.classList.add("is-empty");
      }

      cartDrawer.getSectionsToRender().forEach(function (section) {
        var sectionElement = section.selector
          ? document.querySelector(section.selector)
          : document.getElementById(section.id);
        if (!sectionElement || !parsedState.sections[section.id]) return;
        sectionElement.innerHTML = cartDrawer.getSectionInnerHTML(
          parsedState.sections[section.id],
          section.selector
        );
      });
    }

    function updateCartQuantity(variantId, quantity) {
      var payload = {
        updates: {},
        sections: ["cart-drawer", "cart-icon-bubble"],
        sections_url: window.location.pathname,
      };
      payload.updates[String(variantId)] = quantity;

      return fetch(routes.cart_update_url, Object.assign({}, fetchConfig(), { body: JSON.stringify(payload) }))
        .then(function (res) {
          return res.json();
        })
        .then(function (parsedState) {
          if (parsedState.errors) {
            throw new Error(parsedState.errors);
          }
          cartDataCache = parsedState;
          renderCartSections(parsedState);
          if (typeof publish === "function" && typeof PUB_SUB_EVENTS !== "undefined") {
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: "card-product-v2",
              cartData: parsedState,
            });
          }
          return parsedState;
        });
    }

    function syncAllCards(cartData) {
      if (!cartData) return;
      cartDataCache = cartData;
      $(CARD_SEL).each(function () {
        var $card = $(this);
        var variantId = $card.find("[data-cpv2-variant-input]").val();
        updateCardCartUI($card, getVariantQtyFromCart(cartData, variantId));

        $card.find("[data-cpv2-variant]").each(function () {
          var $pill = $(this);
          $pill.attr(
            "data-variant-cart-qty",
            getVariantQtyFromCart(cartData, $pill.attr("data-variant-id"))
          );
        });
      });
    }

    function moneyFromCents(cents) {
      if (typeof Shopify !== "undefined" && typeof Shopify.formatMoney === "function") {
        var format =
          (window.theme && theme.moneyFormat) ||
          (window.Shopify && Shopify.money_format) ||
          "{{amount}}";
        try {
          return Shopify.formatMoney(cents, format);
        } catch (e) {
          /* fall through */
        }
      }
      return "Rs. " + (Number(cents) / 100).toFixed(2);
    }

    function applyVariant($card, variant) {
      if (!variant) return;

      var $input = $card.find("[data-cpv2-variant-input]");
      if (variant.id) $input.val(variant.id);

      var priceText = "";
      if (typeof variant.price === "number") {
        priceText = moneyFromCents(variant.price);
      } else if (variant.price) {
        priceText = String(variant.price);
      }
      if (priceText) {
        $card.find("[data-cpv2-price]").text(priceText.replace(/\s*\/-\s*$/, "") + "/-");
      }

      var qty = cartDataCache
        ? getVariantQtyFromCart(cartDataCache, variant.id)
        : 0;
      updateCardCartUI($card, qty);

      var $add = $card.find("[data-cpv2-add-btn]");
      var $form = $card.find("[data-cpv2-product-form]");
      var $sold = $card.find(".cpv2-card__add--soldout");

      if (variant.available) {
        $form.removeClass("is-hidden");
        if (qty > 0) {
          $form.addClass("is-hidden");
        }
        $add.prop("disabled", false);
        $sold.remove();
      } else {
        $form.addClass("is-hidden");
        $card.find("[data-cpv2-qty]").attr("hidden", true).removeClass("is-visible");
        if (!$sold.length) {
          $card
            .find("[data-cpv2-actions]")
            .append(
              '<button type="button" class="cpv2-card__add cpv2-card__add--soldout" disabled>Sold out</button>'
            );
        }
      }
    }

    function findVariantFromOptions($card) {
      var $json = $card.find("[data-cpv2-variants-json]");
      if (!$json.length) return null;

      var variants;
      try {
        variants = JSON.parse($json.text());
      } catch (e) {
        return null;
      }

      var selected = [];
      $card.find("[data-cpv2-option-row]").each(function () {
        var $active = $(this).find("[data-cpv2-option-value].is-active").first();
        selected.push($active.attr("data-option-value") || "");
      });

      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        var opts = v.options || [];
        var match = true;
        for (var j = 0; j < selected.length; j++) {
          if (String(opts[j]) !== String(selected[j])) {
            match = false;
            break;
          }
        }
        if (match) return v;
      }
      return null;
    }

    function bindEvents() {
      if (bound) return;
      bound = true;

      $(document).on("click.cpv2", "[data-cpv2-variant]", function () {
        var $btn = $(this);
        if ($btn.is(":disabled")) return;

        var $card = $btn.closest(CARD_SEL);
        $card.find("[data-cpv2-variant]").removeClass("is-active");
        $btn.addClass("is-active");

        applyVariant($card, {
          id: $btn.attr("data-variant-id"),
          price: $btn.attr("data-variant-price"),
          available: $btn.attr("data-variant-available") === "true",
        });

        // price attr already formatted money string
        if ($btn.attr("data-variant-price")) {
          $card.find("[data-cpv2-price]").text($btn.attr("data-variant-price") + "/-");
        }

        var qty = cartDataCache
          ? getVariantQtyFromCart(cartDataCache, $btn.attr("data-variant-id"))
          : parseInt($btn.attr("data-variant-cart-qty"), 10) || 0;
        updateCardCartUI($card, qty);
      });

      $(document).on("click.cpv2", "[data-cpv2-option-value]", function () {
        var $btn = $(this);
        if ($btn.is(":disabled")) return;

        var $row = $btn.closest("[data-cpv2-option-row]");
        var $card = $btn.closest(CARD_SEL);
        $row.find("[data-cpv2-option-value]").removeClass("is-active");
        $btn.addClass("is-active");

        var variant = findVariantFromOptions($card);
        if (variant) applyVariant($card, variant);
      });

      $(document).on("click.cpv2", "[data-cpv2-qty-plus]", function () {
        var $card = $(this).closest(CARD_SEL);
        var variantId = $card.find("[data-cpv2-variant-input]").val();
        var currentQty = parseInt($card.find("[data-cpv2-qty-value]").text(), 10) || 0;
        var $btn = $(this);
        if (!variantId) return;

        $btn.addClass("is-loading").prop("disabled", true);
        updateCartQuantity(variantId, currentQty + 1)
          .then(function (cartData) {
            syncAllCards(cartData);
          })
          .catch(function (err) {
            console.warn("[CardProductV2] qty increase error:", err);
          })
          .finally(function () {
            $btn.removeClass("is-loading").prop("disabled", false);
          });
      });

      $(document).on("click.cpv2", "[data-cpv2-qty-minus]", function () {
        var $card = $(this).closest(CARD_SEL);
        var variantId = $card.find("[data-cpv2-variant-input]").val();
        var currentQty = parseInt($card.find("[data-cpv2-qty-value]").text(), 10) || 0;
        var $btn = $(this);
        if (!variantId || currentQty <= 0) return;

        $btn.addClass("is-loading").prop("disabled", true);
        updateCartQuantity(variantId, currentQty - 1)
          .then(function (cartData) {
            syncAllCards(cartData);
          })
          .catch(function (err) {
            console.warn("[CardProductV2] qty decrease error:", err);
          })
          .finally(function () {
            $btn.removeClass("is-loading").prop("disabled", false);
          });
      });

      if (typeof subscribe === "function" && typeof PUB_SUB_EVENTS !== "undefined") {
        subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
          if (!event.cartData) return;
          ensureFullCartData(event.cartData).then(function (fullCart) {
            if (fullCart) syncAllCards(fullCart);
          });
        });
      }
    }

    function boot() {
      bindEvents();
      fetchCartData().then(function (cartData) {
        if (cartData) syncAllCards(cartData);
      });
    }

    boot();

    document.addEventListener("shopify:section:load", function () {
      fetchCartData().then(function (cartData) {
        if (cartData) syncAllCards(cartData);
      });
    });
  })();

  /* -------------------------------------------------------------------------
   * Contact Us tabs
   * Markup: sections/contact-us-tabs.liquid
   * The tab strip is a set of real links; here they are upgraded to pushState
   * so ?tab=… stays in sync without reloading the page.
   * ---------------------------------------------------------------------- */
  (function initContactTabs() {
    var SECTION_SEL = "[data-ctu-section]";
    var STORAGE_KEY = "ctu:last-tab";

    function remember(key) {
      try {
        sessionStorage.setItem(STORAGE_KEY, key);
      } catch (e) {
        /* private mode — tab state simply won't survive the form redirect */
      }
    }

    function recall() {
      try {
        return sessionStorage.getItem(STORAGE_KEY);
      } catch (e) {
        return null;
      }
    }

    function urlForTab(key) {
      var url = new URL(window.location.href);
      url.searchParams.set("tab", key);
      url.searchParams.delete("contact_posted");
      url.hash = "";
      return url.pathname + url.search;
    }

    function activate($section, key) {
      if (!key || !$section.find('[data-ctu-panel="' + key + '"]').length) return false;

      $section.find("[data-ctu-tab]").each(function () {
        var isActive = $(this).attr("data-ctu-tab") === key;
        $(this)
          .toggleClass("is-active", isActive)
          .attr("aria-selected", isActive ? "true" : "false");
      });

      $section.find("[data-ctu-panel]").each(function () {
        var isActive = $(this).attr("data-ctu-panel") === key;
        $(this).toggleClass("is-active", isActive).prop("hidden", !isActive);
      });

      return true;
    }

    function scrollTabsIntoView($section) {
      var el = $section.find(".ctu__tabs")[0];
      if (!el) return;

      var top = el.getBoundingClientRect().top;
      if (top >= 0) return;

      window.scrollTo({ top: window.pageYOffset + top - 20, behavior: "smooth" });
    }

    function syncFromUrl() {
      var params = new URLSearchParams(window.location.search);
      var urlKey = params.get("tab");
      var posted = params.get("contact_posted");

      $(SECTION_SEL).each(function () {
        var $section = $(this);
        var key = urlKey;

        if (!key && posted) key = recall();
        if (!activate($section, key)) {
          activate($section, $section.attr("data-default-tab"));
          return;
        }

        // Keep a shareable URL after the contact form redirect drops ?tab.
        if (!urlKey && window.history && window.history.replaceState) {
          window.history.replaceState({ ctuTab: key }, "", urlForTab(key));
        }
      });
    }

    $(document).on("click.ctu", "[data-ctu-tab]", function (event) {
      // Let modified clicks fall through so "open in new tab" keeps working.
      if (event.button > 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

      var $tab = $(this);
      var $section = $tab.closest(SECTION_SEL);
      var key = $tab.attr("data-ctu-tab");
      if (!$section.length || !activate($section, key)) return;

      event.preventDefault();
      remember(key);

      if (window.history && window.history.pushState) {
        window.history.pushState({ ctuTab: key }, "", urlForTab(key));
      }

      scrollTabsIntoView($section);
    });

    $(document).on("click.ctu", "[data-ctu-office]", function () {
      var $btn = $(this);
      var $group = $btn.closest("[data-ctu-offices]");
      var key = $btn.attr("data-ctu-office");

      $group.find("[data-ctu-office]").each(function () {
        var isActive = $(this).attr("data-ctu-office") === key;
        $(this)
          .toggleClass("is-active", isActive)
          .attr("aria-selected", isActive ? "true" : "false");
      });

      $group.find("[data-ctu-office-panel]").each(function () {
        var isActive = $(this).attr("data-ctu-office-panel") === key;
        $(this).toggleClass("is-active", isActive).prop("hidden", !isActive);
      });
    });

    $(document).on("submit.ctu", "[data-ctu-form]", function () {
      remember($(this).attr("data-ctu-form"));
    });

    $(window).on("popstate.ctu", function () {
      var key = new URLSearchParams(window.location.search).get("tab");

      $(SECTION_SEL).each(function () {
        var $section = $(this);
        if (!activate($section, key)) activate($section, $section.attr("data-default-tab"));
      });
    });

    syncFromUrl();

    document.addEventListener("shopify:section:load", function (event) {
      if ($(event.target).find(SECTION_SEL).length || $(event.target).is(SECTION_SEL)) syncFromUrl();
    });
  })();

  /* =========================================================================
   * Menu Subcollections
   * -------------------------------------------------------------------------
   * Section: sections/menu-subcollections.liquid
   * Styles:  assets/custom-ai.css
   * Behaviour: tab click swaps the sub-collection card grid below
   * ========================================================================= */
  (function initMenuSubcollections() {
    var SECTION_SEL = "[data-msc-section]";

    function activateTab($section, panelId) {
      var $tabs = $section.find("[data-msc-tab]");
      var $panels = $section.find("[data-msc-panel]");
      var $activeTab = $tabs.filter('[data-msc-panel-id="' + panelId + '"]');
      var $activePanel = $panels.filter('[data-msc-panel="' + panelId + '"]');

      if (!$activePanel.length) return;

      $tabs.removeClass("is-active").attr("aria-selected", "false");
      $activeTab.addClass("is-active").attr("aria-selected", "true");

      $panels.removeClass("is-active").attr("hidden", true);
      $activePanel.addClass("is-active").removeAttr("hidden");
    }

    function initSection(sectionEl) {
      var $section = $(sectionEl);
      if ($section.data("msc-initialized")) return;
      $section.data("msc-initialized", true);

      $section.on("click.msc", "[data-msc-tab]", function () {
        activateTab($section, $(this).attr("data-msc-panel-id"));
      });

      var firstId = $section.find(".msc__panel.is-active").attr("data-msc-panel");
      if (firstId) activateTab($section, firstId);
    }

    function boot() {
      $(SECTION_SEL).each(function () {
        initSection(this);
      });
    }

    boot();

    document.addEventListener("shopify:section:load", function (event) {
      $(event.target)
        .find(SECTION_SEL)
        .addBack(SECTION_SEL)
        .each(function () {
          $(this).removeData("msc-initialized");
          initSection(this);
        });
    });
  })();

  /* =========================================================================
   * Watch & Shop
   * -------------------------------------------------------------------------
   * Section: sections/watch-and-shop.liquid
   * Styles:  assets/custom-ai.css -> .was*
   * Behaviour: Swiper + muted autoplay for visible slides (Shopify / YouTube)
   * ========================================================================= */
  (function initWatchAndShop() {
    var SECTION_SEL = "[data-was-section]";

    function whenSwiperReady(callback, attempt) {
      attempt = attempt || 0;
      if (typeof window.Swiper === "function") {
        callback();
        return;
      }
      if (attempt > 40) {
        console.warn("[WatchAndShop] Swiper library not found.");
        return;
      }
      window.setTimeout(function () {
        whenSwiperReady(callback, attempt + 1);
      }, 50);
    }

    function stopCard($card) {
      $card.removeClass("is-playing");

      var video = $card.find(".was-card__video")[0];
      if (video) {
        try {
          video.pause();
          video.currentTime = 0;
        } catch (e) {}
      }

      var $embed = $card.find("[data-was-embed]");
      if ($embed.length) {
        $embed.empty().attr("hidden", true);
      }
    }

    function playShopifyVideo($card) {
      var video = $card.find(".was-card__video")[0];
      if (!video) return;
      video.muted = true;
      video.loop = true;
      video.playsInline = true;
      $card.addClass("is-playing");
      var playPromise = video.play();
      if (playPromise && typeof playPromise.catch === "function") {
        playPromise.catch(function () {});
      }
    }

    function playEmbed($card) {
      var $embed = $card.find("[data-was-embed]");
      if (!$embed.length) return;

      var type = $embed.attr("data-video-type");
      var id = $embed.attr("data-video-id");
      if (!id) return;

      if ($card.hasClass("is-playing") && $embed.find("iframe").length) return;

      var src = "";
      if (type === "youtube") {
        src =
          "https://www.youtube.com/embed/" +
          id +
          "?autoplay=1&mute=1&playsinline=1&controls=0&loop=1&playlist=" +
          id +
          "&rel=0&modestbranding=1";
      } else if (type === "vimeo") {
        src =
          "https://player.vimeo.com/video/" +
          id +
          "?autoplay=1&muted=1&loop=1&background=1&title=0&byline=0&portrait=0";
      } else {
        return;
      }

      $embed
        .html(
          '<iframe src="' +
            src +
            '" title="Watch & Shop video" allow="autoplay; encrypted-media; picture-in-picture" allowfullscreen loading="lazy"></iframe>'
        )
        .removeAttr("hidden");
      $card.addClass("is-playing");
    }

    function playCard($card) {
      if ($card.find(".was-card__video").length) {
        playShopifyVideo($card);
      } else if ($card.find("[data-was-embed]").length) {
        playEmbed($card);
      }
    }

    function getVisibleCards(swiper) {
      var cards = [];
      if (!swiper || !swiper.slides) return cards;

      for (var i = 0; i < swiper.slides.length; i++) {
        var slide = swiper.slides[i];
        if (!slide.classList.contains("swiper-slide-visible")) continue;
        var card = slide.querySelector("[data-was-card]");
        if (card) cards.push(card);
      }

      if (!cards.length && swiper.slides.length) {
        var count = Math.ceil(swiper.params.slidesPerView) || 1;
        for (var j = 0; j < Math.min(count, swiper.slides.length); j++) {
          var fallbackCard = swiper.slides[j].querySelector("[data-was-card]");
          if (fallbackCard) cards.push(fallbackCard);
        }
      }

      return cards;
    }

    function syncPlayback($section, swiper) {
      if (!$section.data("was-in-view")) {
        $section.find("[data-was-card]").each(function () {
          stopCard($(this));
        });
        return;
      }

      var visible = getVisibleCards(swiper);

      $section.find("[data-was-card]").each(function () {
        if (visible.indexOf(this) === -1) stopCard($(this));
      });

      for (var k = 0; k < visible.length; k++) {
        playCard($(visible[k]));
      }
    }

    function bindPlayback($section) {
      $section.off("click.was").on("click.was", "[data-was-play]", function (e) {
        if ($(this).is("a")) return;
        e.preventDefault();

        var $card = $(this).closest("[data-was-card]");
        if (!$card.length) return;

        if ($card.hasClass("is-playing")) {
          var video = $card.find(".was-card__video")[0];
          if (video) video.muted = !video.muted;
          return;
        }

        playCard($card);
      });
    }

    function observeSection($section, swiper) {
      if (!("IntersectionObserver" in window)) {
        $section.data("was-in-view", true);
        syncPlayback($section, swiper);
        return;
      }

      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            $section.data("was-in-view", entry.isIntersecting);
            syncPlayback($section, swiper);
          });
        },
        { rootMargin: "80px", threshold: 0.15 }
      );

      observer.observe($section[0]);
    }

    function createSwiper(swiperEl, $section) {
      if (!swiperEl || typeof window.Swiper !== "function") return null;

      if (swiperEl.swiper) {
        swiperEl.swiper.destroy(true, true);
      }

      return new window.Swiper(swiperEl, {
        slidesPerView: 1.35,
        spaceBetween: 14,
        speed: 450,
        watchOverflow: true,
        watchSlidesProgress: true,
        navigation: {
          prevEl: $section.find("[data-was-prev]")[0],
          nextEl: $section.find("[data-was-next]")[0],
        },
        breakpoints: {
          750: {
            slidesPerView: 2.4,
            spaceBetween: 16,
          },
          990: {
            slidesPerView: 4,
            spaceBetween: 16,
          },
          1200: {
            slidesPerView: 5,
            spaceBetween: 16,
          },
        },
        on: {
          init: function () {
            var self = this;
            window.setTimeout(function () {
              syncPlayback($section, self);
            }, 80);
          },
          slideChangeTransitionEnd: function () {
            syncPlayback($section, this);
          },
          resize: function () {
            syncPlayback($section, this);
          },
        },
      });
    }

    function initSection(sectionEl) {
      var $section = $(sectionEl);
      if ($section.data("was-initialized")) return;
      $section.data("was-initialized", true);

      bindPlayback($section);

      var swiperEl = $section.find("[data-was-swiper]")[0];
      var swiper = swiperEl ? createSwiper(swiperEl, $section) : null;
      if (swiper) observeSection($section, swiper);
    }

    function boot() {
      whenSwiperReady(function () {
        $(SECTION_SEL).each(function () {
          initSection(this);
        });
      });
    }

    boot();

    document.addEventListener("shopify:section:load", function (event) {
      $(event.target)
        .find(SECTION_SEL)
        .addBack(SECTION_SEL)
        .each(function () {
          $(this).removeData("was-initialized");
          initSection(this);
        });
    });
  })();

  /* =========================================================================
   * Footer — mobile accordion for menu columns
   * -------------------------------------------------------------------------
   * Section: sections/footer.liquid
   * Only active below 768px; desktop columns stay always open.
   * ========================================================================= */
  (function initFooterMobileAccordion() {
    var MQ = window.matchMedia("(max-width: 767px)");

    function isMobile() {
      return MQ.matches;
    }

    function syncDesktopState() {
      if (!isMobile()) {
        document.querySelectorAll("[data-footer-accordion]").forEach(function (details) {
          details.setAttribute("open", "");
        });
      }
    }

    function resetMobileState() {
      if (isMobile()) {
        document.querySelectorAll("[data-footer-accordion]").forEach(function (details) {
          details.removeAttribute("open");
        });
      }
    }

    function bindAccordions() {
      document.querySelectorAll("[data-footer-accordion]").forEach(function (details) {
        if (details.dataset.footerAccordionBound) return;
        details.dataset.footerAccordionBound = "true";

        details.addEventListener("toggle", function () {
          if (!isMobile() || !details.open) return;

          document.querySelectorAll("[data-footer-accordion]").forEach(function (other) {
            if (other !== details && other.open) {
              other.open = false;
            }
          });
        });
      });
    }

    function boot() {
      bindAccordions();
      syncDesktopState();
    }

    boot();

    if (typeof MQ.addEventListener === "function") {
      MQ.addEventListener("change", function () {
        syncDesktopState();
        resetMobileState();
      });
    } else if (typeof MQ.addListener === "function") {
      MQ.addListener(function () {
        syncDesktopState();
        resetMobileState();
      });
    }

    document.addEventListener("shopify:section:load", function (event) {
      if (event.target.querySelector("[data-footer-accordion]")) {
        boot();
      }
    });
  })();

});
